import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Format a YYYY-MM-DD string as "Month Day, Year" (e.g. "March 3, 1952").
 * Returns an empty string when the input is falsy or unparseable.
 * Parses manually to avoid timezone drift that can shift the day.
 */
export function formatBirthDate(
  date: string | null | undefined,
  fallbackYear?: number | null
): string {
  if (date && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
    const [y, m, d] = date.split('-').map(Number);
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December',
    ];
    if (m >= 1 && m <= 12) return `${months[m - 1]} ${d}, ${y}`;
  }
  if (fallbackYear) return String(fallbackYear);
  return '';
}

/** Extract YYYY from a YYYY-MM-DD string, or return undefined. */
export function yearFromDate(date: string | null | undefined): number | undefined {
  if (date && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
    const y = parseInt(date.slice(0, 4), 10);
    if (!Number.isNaN(y)) return y;
  }
  return undefined;
}
